// @flow
import $ from 'jquery';
import JQueryView, { on } from '../../../common/JQueryView';

export default class ConfirmView extends JQueryView {
  constructor() {
    super('.en_confirm');
  }

  @on({
    event: 'change',
    selector: '#officer_approval_stockholder_meeting_en_comment',
  })
  onChangeEnComment() {
    const comment = $('#officer_approval_stockholder_meeting_en_comment').val();
    $('input:hidden[name="en_test_comment"]').val(comment);
  }

  @on({
    event: 'click',
    selector: '#use_sample',
  })
  onClickUseSample() {
    const body = $('#sample_sentence_body')
      .find('p')
      .text();
    const enTextarea = $('#officer_approval_stockholder_meeting_en_comment');
    enTextarea.val(body);
    $('input:hidden[name="en_test_comment"]').val(body);
  }
}
